import { TFunction } from 'i18next';
import { allCountries } from 'models/utils/countries';

/**
 * Returns the display string for a segmentation rule's value (e.g. "mobile", "United Kingdom").
 * Shared by SelectedSegmentationRules and formatSegmentationForTooltip.
 */
export const getSegmentRuleDisplayValue = (
  rule: { type: string; configuration?: { value?: string } },
  t: TFunction,
): string => {
  switch (rule.type) {
    case 'geoLocation':
    case 'shippingCountry':
      return allCountries[rule.configuration?.value] ?? rule.configuration?.value ?? '';
    case 'url':
    case 'basketSource':
    case 'basketType':
    case 'basketValue':
    case 'repopulationUrl':
    case 'itemName':
    case 'itemUrl':
    case 'itemId':
    case 'itemCategory':
    case 'legacy':
      return rule.configuration?.value ?? '';
    default:
      return rule.configuration?.value ? t(`onsite.segmentationRules.values.${rule.configuration.value}`) : '';
  }
};
